<template>
  <div :class="['payment-list',{'app': isNativeApp}]">
    <!-- 方案解析列表 -->
    <div v-show="solutions.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :offset="80"
        @load="onLoad"
      >
        <div class="list-content">
          <van-row class="list-item" v-for="(item, index) of solutions" :key="index">
              <van-col :span="15" @click="toDetail(item.businessId)">
                <van-row  class="list-item-title">
                  <div> <i class="blue_icon"></i>{{item.businessName}}</div>
                </van-row>
                <van-row class="list-item-count">
                  <div class="item-user"><img src="../assets/images/icon_on.png" alt="">{{item.solutionAuthor}}</div>
                </van-row>
              </van-col>
             <!-- <van-col :span="4" class="list-item-btn">
                <span @click="toPay(item)">支付</span>
              </van-col> -->
              <van-col  class="list-item-btn">
                <span @click="unPay(item)" style="background: #C8C9CC;border: 1px solid #C8C9CC;">取消支付</span>
                <span @click="toPay(item)">支付</span>
              </van-col>
          </van-row>
        </div>
      </van-list>
    </div>
    <noPaymentList v-show="solutions.length <= 0"></noPaymentList>
  </div>
</template>

<script>
import { textSlice, myriabit } from '@/filters/commonFilters'
import { getPaymentList } from '@/api/news/news'
import { dealAwaitOrder, getOrderInfoByOrderNo,cancelOrder } from '@/api/solutions/solution'
import noPaymentList from '@/components/noPaymentList'
import { Toast } from 'vant'
import { toLogin } from '@/utils/common'
import { getCookie } from '@/utils/cookies'
import { Dialog } from 'vant'
import miniProgramPayment from '@/mixins/miniProgramPayment'
export default {
  name: 'list',
  mixins: [miniProgramPayment],
  filters: {
    textSlice,
    myriabit
  },
  components: { noPaymentList },
  data () {
    return {
      loading: false,
      finished: false,
      paramsData: {
        current: 1,
        size: 10,
        payStatus: 20,
        userId: null
      },
      solutions: [],
      noData: false,
      noResultData: {
        typeName: '方案',
        callback: 'callback'
      },
      defaultImg: '../assets/images/icon_user.png',
      isNativeApp: true
    }
  },
  created () {
    this.getData()
    this.paramsData.userId = getCookie('accountId')
    this.isNativeApp = !!(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
    if ($HMD$.rNavigator && $HMD$.rNavigator !== 'msite' && !this.paramsData.userId) {
      let _this = this
      $HMD$.GetLogin(function (data) {
        if (data.AccountId) {
          _this.paramsData.userId = data.AccountId
        } else {
          toLogin()
        }
      })
    }
  },
  methods: {
    getAppAccountId() {
      return new Promise((resolve, reject) =>{
        $HMD$.GetLogin(function (data) {
          resolve(data && data.AccountId || '')
        })
      });
    },
    onLoad () {
      // 调用查询接口
      let self = this
      this.paramsData.current++
      getPaymentList(this.paramsData).then(result => {
        if (result && result.status === 200 && result.data && result.data.respCode === '0000' && result.data.data && result.data.data.records && result.data.data.records.length > 0) {
          self.solutions = self.solutions.concat(result.data.data.records)
          self.paramsData.current = result.data.data.current
          window.setTimeout(() => {
            self.loading = false
            if (result.data.data.current === result.data.data.pages) {
              self.finished = true
            }
          }, 1000)
        } else {
          self.loading = false
          self.finished = true
        }
      }).catch(() => {
        self.loading = false
        self.paramsData.total = 0
      })
    },
    getData () {
      this.paramsData.current = 0
      this.paramsData.size = 10
      this.finished = false
      this.noData = false
      this.onLoad()
    },
    toListSelf () {
      this.getData()
    },
    toDetail (id) {
      window.location.href = `/solutions/detail/${id}.html`
    },
    toPay (item) {
      this.doAwaitOrder(item)
      event.stopPropagation()
    },
    // 取消支付
    unPay(item){
      Dialog.confirm({
        title: '',
        message: '确认取消支付?'
      }).then(() => {
        let param = {
          orderId:item.orderNo
        }
       cancelOrder(param).then(res => {
         console.log(res);
         if(res.data.respCode == '0000'){
           Toast('取消支付成功');
           this.solutions = [];
           this.getData();
         }
       })
      }).catch(() => {
        // 取消
      })
    },
    async doAwaitOrder (item) {
      let userId = getCookie('accountId')
      if ($HMD$.rNavigator && $HMD$.rNavigator !== 'msite' && !userId) {
        let accountId = await this.getAppAccountId()
        if (accountId) {
            userId = accountId
        }else {
            toLogin()
        }
      }
      let postData = {
        businessId: item.businessId,
        businessName: item.businessName,
        businessType: item.businessType,
        orderNo: item.orderNo,
        os: $HMD$.rNavigator && $HMD$.rNavigator === 'msite' ? 'wap' : $HMD$.rNavigator,
        // returnUrl: 'https://pay.' + $HMD$.rApi.S + 'homedo.com/Cashier/FrontReturnCallback',
        userId: userId
      }
      dealAwaitOrder(item.orderNo, postData).then(res => {
        console.log(res.data.data)
        if (res.status === 200 && res.data.respCode === '0000') {
          if (this.isMiniProgram()) {
            this.getOrderIdToMiniProgram(item.orderNo)
          } else if (window.$HMD$.rNavigator.toLowerCase() === 'ios') {
            this.getOrderIdToIos(item.orderNo, res.data.data.url)
          } else {
            window.location.href = res.data.data.url
          }
        } else {
          Toast('抱歉，下载权限校验失败!')
        }
      })
    },
    getOrderIdToIos (orderNo, jumpUrl) {
      getOrderInfoByOrderNo(orderNo).then((res) => {
        if (res.data.code !== 1000 && res.data.msg === '处理成功') {
          // eslint-disable-next-line no-undef
          $HMD$.M.sendApp({
            'name': 'FangAnGuanOrderId',
            'orderId': res.data.code && res.data.code.toString()
          })
        }
        window.location.href = jumpUrl
      })
    }
  }
}
</script>

<style scoped lang="scss">

@mixin TwoLine {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.payment-list.app{
  margin-top: 1.2rem;
}
.payment-list{
  margin-top: 3.85rem;
  .list-content{
    border-bottom: 1px solid #D8D8D8;
    .list-item{
      margin-top: 10px;
      background-color: #ffffff;
      padding: 16px 16px 13px 16px;
      position: relative;
      .list-item-title{
        font-size: 14px;
        font-weight: 400;
        color: #222222;
        div{
          // min-height:16px;
          display: flex;
        .blue_icon{
          width: 3px;
          height: 16px;
          flex-shrink: 0;
          border-radius: 3px;
          margin: 0 15px 0 7px;
          background: #2F7BFF;
        }
        }
      }
      .list-item-count{
        .item-user{
          position: relative;
          font-size: 12px;
          font-weight: 400;
          color: #9B9B9B;
          padding-left: 24px;
          margin-top: 5px;
          img{
            width: 14px;
            height: 14px;
            position: absolute;
            top: 1px;
            left: 0;
          }
        }
      }
      .list-item-btn{
        display: flex;
        flex-direction: row;
        position: absolute;
        right: 16px;
        top: 30%;
        span{
          display: inline-block;
          margin-right: 10px;
          width: 54px;
          height: 24px;
          background: #2F7BFF;
          border-radius: 2px;
          border: 1px solid #2F7BFF;
          font-size: 12px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
          text-align: center;
        }
      }
    }
  }
  .no-data-content{
    background-color: #f5f5f5;
    text-align: center;
    padding-top: 111px;
    .describe-content{
      p{
        font-size: 14px;
        color: #a0a0a0;
        margin: 0px;
      }
    }
    .button-content{
      button{
        margin-top: 40px;
        width: 200px;
        height: 44px;
        background-color: #1dbfda;
        color: white;
        border: none;
        border-radius: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/unPaymentList.vue